export default __webpack_public_path__ + "static/media/V344_CoC.decbe2b1.pdf";